import React, { useEffect, useState } from "react";
import DashBoardNavbar from "../Comps/DashBoard/DashBoardNavbar";
import ReportsNavbar from "../Comps/Reports/ReportsNavbar";
import ReportsBody from "../Comps/Reports/ReportsBody";
import Loading from "../Comps/Extra/Loading";
import BlockReportsNavbar from "../Comps/Block Data Reports/BlockReportsNavbar";
import BlockReportsBody from "../Comps/Block Data Reports/BlockReportsBody";
import { BsTrainFrontFill } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import CustomHeading from "../Comps/Extra/CustomHeading";
const BlockDashBoard = () => {
  const [activeReportPage, setActiveReportPage] = useState("Block Reports");
  const location = useLocation();
  const payload = location.state;
  useEffect(() => {
    if (payload?.activeReportPage) {
      setActiveReportPage(payload?.activeReportPage);
    }
  }, [payload]);
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div className=" text-center m-1 " style={{ minHeight: "90vh" }}>
      <div className=" ">
        {/* <h2 className="d-flex align-items-center justify-content-center">
          <BsTrainFrontFill />
          Block Dashboard
        </h2> */}
        <CustomHeading
          text={{
            heading: "Block Dashboard",
            subText: "Block Management System",
          }}
          icon={BsTrainFrontFill}
          style={{
            height: "100px",

            // Main container
            width: "100%",
            borderRadius: "24px",
            shadow: "0 10px 30px rgba(0,0,0,0.15)",
            background: "#fff",

            // Gradient
            gradient: true,
            color: ["#870606", "#bb0a0a", "#732f08"],
            gradientDirection: "120deg",

            // Heading
            headingColor: "#ffffff",
            headingSize: "clamp(2rem, 5vw, 3.5rem)",
            headingWidth: "520px",

            // Subtitle
            subtitleColor: "#f4f7fb",
            subtitleSize: "0.95rem",
            subtitleMaxWidth: "650px",
            subtitleLineHeight: 1.5,

            // Content
            contentGap: "4px",
          }}
        />
      </div>

      <BlockReportsNavbar
        activeReportPage={activeReportPage}
        setActiveReportPage={setActiveReportPage}
      />
      <BlockReportsBody activeReportPage={activeReportPage} />
    </div>
  );
};
export default BlockDashBoard;
